import React from "react";

const OPTIONS = [
  { value: "list", label: "List" },
  { value: "analysis", label: "Analysis" },
];

export default function StockHoldingsViewToggle({ value, onChange }) {
  return (
    <div role="tablist" aria-label="Holdings view" className="stock-holdings-view-toggle">
      {OPTIONS.map((opt) => {
        const active = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            role="tab"
            aria-selected={active}
            className={`stock-holdings-view-toggle__btn${active ? " stock-holdings-view-toggle__btn--active" : ""}`}
            onClick={() => onChange(opt.value)}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
